import React from 'react'
import { Dialog as MUIDialog, DialogProps as MUIDialogProps } from '@material-ui/core'

export interface DialogProps extends MUIDialogProps {}

export const Dialog = (props: DialogProps) => <MUIDialog data-dls="atom-dialog" {...props} />

export default Dialog
